import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from '../../../public-shared/public-shared.module';
import { SharedModule } from '../../../../shared/shared.module';
import { FreePaymentComponent } from './free-payment.component';

const freePaymentRoutes: Routes = [
  {
    path: '',
    component: FreePaymentComponent,
	children: [
		{
			path: 'buyerinfo',
			loadChildren: () => import('../buyer-info/buyer-info.module').then(m => m.BuyerInfoModule)
		}
	]
  }
];

@NgModule({
  declarations: [
    FreePaymentComponent,
  ],
  imports: [
    RouterModule.forChild(freePaymentRoutes),
    PublicSharedModule,
    SharedModule,
    CommonModule,
  ]
})
export class FreePaymentModule { }
